import { TableColumnType } from 'src/types/table';

export const allColumns: TableColumnType[] = [
    { key: 'NAME', label: 'name', defaultShow: true },
    { key: 'PACKAGE_TYPE_SSRC', label: 'packageType', customRender: true, defaultShow: true },
];
